import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputReadOnlyUI from '../../../widgets/form/InputReadOnlyUI'

const DirectorCreateModalUI = ({context, successMsg, errorList, setErrorList,
    // modes
    submitted, createMode,
    // event handlers
    onSubmit, onCancelClick,
    //
    directorName, onDirectorNameChange, directorNameError, setDirectorNameError,
    directorNumber, onDirectorNumberChange, directorNumberError, setDirectorNumberError,
    phoneNumber, onPhoneNumberChange, phoneNumberError, setPhoneNumberError,
    address, onAddressChange, addressError, setAddressError,
    email, onEmailChange, emailError, setEmailError,
  }) =>
  <ModalFormUI
    context={context}
    titleLabel='Add director'
    buttonLabel='Add'
    cancelLabel='Cancel'
    isOpen={createMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF type='text'  name='directorName' label='Director name'
      required={true} maxLength={100} autoFocus={true}
      value={directorName} onChange={onDirectorNameChange}
      error={directorNameError} setError={setDirectorNameError}
    />
    <InputTextSF type='text'  name='directorNumber' label='Director number (DIN)'
      required={true} maxLength={10}
      value={directorNumber} onChange={onDirectorNumberChange}
      error={directorNumberError} setError={setDirectorNumberError}
    />
    <InputTextSF type='text'  name='phoneNumber' label='Phone number'
      maxLength={20}
      value={phoneNumber} onChange={onPhoneNumberChange}
      error={phoneNumberError} setError={setPhoneNumberError}
    />
    <InputTextSF type='text'  name='address' label='Address'
      maxLength={100}
      value={address} onChange={onAddressChange}
      error={addressError} setError={setAddressError}
    />
    {/*
    <InputTextSF type='text'  name='email' label='Email'
      maxLength={40}
      value={email} onChange={onEmailChange}
      error={emailError} setError={setEmailError}
    />
    */}
  </ModalFormUI>

export default DirectorCreateModalUI
